import { useEffect, useState } from 'react';
import { UnsupportedChainIdError, useWeb3React } from '@web3-react/core';
import { type providers } from 'ethers';
import { getChainIdFromEnv } from './supportedChains.ts';

export function useIsUnsupportedChain(): boolean {
    const [unsupportedChain, setUnsupportedChain] = useState(false);
    const { active, error, chainId } = useWeb3React<providers.JsonRpcProvider>();

    useEffect(() => {
        if ((active && chainId !== undefined) || error) {
            const isUnsupportedChain =
                error instanceof UnsupportedChainIdError || chainId !== getChainIdFromEnv();
            setUnsupportedChain(isUnsupportedChain);
        }
    }, [error, chainId, active]);

    useEffect(() => {
        (async function getInitialChainId() {
            if (!window.ethereum) {
                return;
            }
            const initialChainId = await window.ethereum.request({ method: 'eth_chainId' });
            const isUnsupportedChain = Number(initialChainId) !== getChainIdFromEnv();
            setUnsupportedChain(isUnsupportedChain);
        })();
    }, []);

    return unsupportedChain;
}
